import React from 'react';

import { Container } from './styles';

import logo from '../../assets/logo-cute.png';

function Main() {
    return (
        <Container>
            <section>
                <h1>Play Music in your discord server?</h1>
                <p>Soudy can liven up your afternoons by playing songs and a playlist.</p>
                <a href="https://discord.com/oauth2/authorize?client_id=438849443949969408&scope=bot&permissions=0">
                    <button>
                        Add to discord
                </button>
                </a>
            </section>

            <figure>
                <img src={logo} alt="Logo" />
            </figure>


        </Container>
    );
}

export default Main;